import { Navigate, Outlet } from 'react-router-dom';
import { useUserContext } from '../contexts/UserContext';

const PrivateRoute = () => {
  const { IsAuthenticated } = useUserContext();
  return IsAuthenticated() ? <Outlet /> : <Navigate to="/signIn" />;
};

export default PrivateRoute;
